import { Button } from "@mui/material";
import React from "react";

const FormButton = (props) => {
  return (
    <Button
      {...props}
      sx={{ width: "150px" }}
      color="primary"
      size="large"
      variant="contained"
      type="submit"
    >
      {props.children}
    </Button>
  );
};

export default FormButton;
